/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.busyModule')

/**
 * BulbBusyCoverService manages the busy indicator, cursor.
 */
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  .service('BulbBusyCoverService', ['$document', '$q', '$http', '$templateCache', BulbBusyService]);

function BulbBusyService($document, $q, $http, $templateCache) {

  const templateUrl = 'ajs/components/busy/busy-cover.html';

  let instance = null;
  let busyCount = 0;

  function onKeydown(event) {
    event.preventDefault();
  }

  function createInstance() {
    const deferred = $q.defer();
    if (busyCount === 1) {

      // Prevent keydown events while the busy modal is displayed:
      $document.on('keydown', onKeydown);

      $http.get(templateUrl, { cache: $templateCache }).then((result) => {
        instance = $(result.data);
        $('body').append(instance);
      }).finally(() => {
        deferred.resolve();
      });
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  }

  function removeInstance() {
    if (instance) {
      instance.remove();
      instance = null;
    }
  }

  function hideBusy() {
    busyCount -= 1;
    if (busyCount <= 0) {
      busyCount = 0;
      $document.off('keydown', onKeydown);
      removeInstance();
    }
  }

  /**
   * Show the busy indicator during the processing of the promise.  When the promise is resolved or rejected, remove
   * the busy indicator.
   * Call can be called multiple times, and the busy indicator will remain until all the promises are resolved.
   * @param promise Promise indicating how long to show the busy indicator.
   * @returns {Promise} The original promise so that the original caller can chain the call.
   */
  this.showBusyDuring = function showBusyDuring(promise) {
    busyCount += 1;
    createInstance().finally(() => {
      promise.finally(hideBusy);
    });
    return promise;
  };

  /**
   * Function shows the busy indicator, and returns a function that should be called when the caller is no longer
   * busy.
   * @returns {Function} Function to be called to remove the busy indicator.
   */
  this.showBusy = function showBusy() {
    const deferred = $q.defer();
    this.showBusyDuring(deferred.promise);
    return deferred.resolve;
  };
}
